module.exports = __webpack_public_path__ + "static/media/fridge.48fb7d1e.png";